import axios from "axios";
import { notify } from "@kyvg/vue3-notification";

export default {
    namespaced: true,

    state: () => ({
        notificationsList: [],
        latestNotifications: {
            newCount: 0,
            notifications: [],
            reminders: [],
        },
        optionsLabels: null,
        optionsList: null,
        customTemplates: [],
        templateParams: [],
    }),

    mutations: {
        setNotificationsList(state, data) {
            state.notificationsList = data;
        },
        setLatestNotification(state, data) {
            state.latestNotifications.newCount = data.newCount;
            state.latestNotifications.notifications = data.items;
        },
        setReminders(state, data) {
            state.latestNotifications.reminders = data.items;
        },
        readNotification(state, data) {
            state.notificationsList = state.notificationsList.map((notif) => {
                if (notif.id == data.id) return data;
                else return notif;
            })
        },
        setOptionsLabels(state, data) {
            state.optionsLabels = data
        },
        setOptionsList(state, data) {
            state.optionsList = data
        },
        setCustomTemplates(state, data) {
            state.customTemplates = data;
        },
        setParams(state, data) {
            state.TemplateParams = data;
        }
    },

    actions: {
        // eslint-disable-next-line no-unused-vars
        async createNotification({ commit }, request) {
            await axios.post(`/notices`, request);
        },
        async deleteReminder({ commit }, data) {
            await axios.delete(`/notices/delete/${data.id}`);
        },
        async editNotification({ commit }, data) {
            await axios.post(`/notices/update/${data.id}`, data);
        },
        async getNotificationsList({ commit }) {
            await axios.get(`/notices`).then(({ data }) => {
                commit("setNotificationsList", data)
            })
        },
        async getLatest({ commit }) {
            await axios.get(`/notices/latest`).then(({ data }) => {
                commit("setLatestNotification", data)
            })
        },
        async getReminders({ commit }) {
            await axios.get(`/notices/reminders`).then(({ data }) => {
                commit("setReminders", data)
            })
        },
        async readNotification({ commit }, request) {
            await axios.put(`/notices/${request.id}`).then(({ data }) => {
                commit("readNotification", data)
            });
        },
        async readAllNotifications() {
            await axios.post(`/notices/mark/all`);
        },
        async getOptionsLabels({ commit }) {
            await axios.get(`/notices/settings/names`).then(({ data }) => {
                commit("setOptionsLabels", data)
            })
        },
        async getOptionsList({ commit }) {
            await axios.get(`/notices/settings`).then(({ data }) => {
                commit("setOptionsList", data)
            })
        },
        // eslint-disable-next-line no-unused-vars
        async saveOptionsNotification({ commit }, request) {
            await axios.post(`/notices/settings`, request);
        },
        async getCustomTemplates({ commit }, request) {
            await axios.get(`/notification/templates`, request).then(({ data }) => {
                commit("setCustomTemplates", data)
            });
        },
        async deleteCustomTemplate({ commit }, request) {
            await axios.delete(`/notification/templates/${request.id}`);
        },
        async updateTemplate({ commit }, request) {
            await axios.patch(`/notification/templates/${request.id}`, request);
        },
        async createTemplate({ commit }, request) {
            await axios.post(`/notification/templates`, request);
        },
        async getAvailableParams({ commit }) {
            await axios.get(`/notification/templates/params`).then(({ data }) => {
                commit("setParams", data)
            });
        }
    }
}